import { isImmutable } from 'immutable';

import { shouldShowForm } from '../../product/shouldShowForm';
import { setIsComplete } from './templates';
import { isObject } from '../../isObject';

import { ALL, PROFILE_TYPE, SECTIONS } from '../../../constants/profiles';
import { EMPTY } from '../../../constants';

export function setAll(sections) {
  function reduceSections(result, selected, item) {
    switch (item) {
      case ALL: {
        return result;
      }

      default: {
        return result && selected;
      }
    }
  }

  return sections.set(ALL, sections.reduce(reduceSections, true));
}

export function getProfileSections({ channel, type, value = false }) {
  function reduceSections(sections, section) {
    if (typeof value === 'boolean') {
      return sections.set(section, value);
    }

    if (typeof value === 'function') {
      return sections.set(section, value(section));
    }

    if (isImmutable(value)) {
      return sections.set(section, value.get(section) || false);
    }

    if (isObject(value)) {
      return sections.set(section, value[section] || false);
    }

    return sections.set(section, false);
  }

  return SECTIONS[channel][type].reduce(reduceSections, EMPTY.MAP);
}

export function updateProfileSections({ profile, section, value }) {
  const sections = setAll(profile.get('sections').set(section, value));

  switch (profile.get('type')) {
    case PROFILE_TYPE.STANDARD: {
      return profile
        .set('sections', sections)
        .set('template', setIsComplete({ sections, template: profile.get('template') }));
    }

    default: {
      return profile.set('sections', sections);
    }
  }
}

export function shapeSectionsForAPI({ channel, profile }) {
  function shapeAiSections() {
    function reduceForms(sections, form) {
      const value = !!profile.getIn(['sections', form]);

      sections[form] = value;
      sections[ALL] = sections[ALL] && value;
      return sections;
    }

    return SECTIONS[channel][PROFILE_TYPE.AI].reduce(reduceForms, { [ALL]: true });
  }

  function shapeStandardSections() {
    const template = profile.get('template');

    function reduceForms(sections, form) {
      const value = !!(
        profile.getIn(['sections', form]) && (
          !template ||
          shouldShowForm({ product: template, type: form })
        )
      );

      sections[form] = value;
      sections[ALL] = sections[ALL] && value;
      return sections;
    }

    return SECTIONS[channel][PROFILE_TYPE.STANDARD].reduce(reduceForms, { [ALL]: true });
  }

  switch (profile.get('type')) {
    case PROFILE_TYPE.AI: {
      return profile.get('channel') === channel
        ? profile.get('sections').toObject()
        : shapeAiSections();
    }

    case PROFILE_TYPE.STANDARD: {
      return shapeStandardSections();
    }

    default: {
      return {};
    }
  }
}
